// extracted by mini-css-extract-plugin
export default {"styleChooserSection":"F2-z","dimensionLabel":"G2-z","styleChooserControlWrapper":"H2-z","styleChooserControl":"I2-z","disabled":"J2-z","giftCard":"K2-z","styleChooserText":"L2-z"};